import type {
  AuthApiUser,
  AuthLoginResponse,
  AuthLoginResponseData,
  AuthSignupResponse,
  AuthSignupResponseData,
} from "@/features/auth/types/signup";

function pickAuthSessionAccessToken(
  data: AuthSignupResponseData | AuthLoginResponseData | undefined | null,
): string | undefined {
  if (!data) return undefined;
  const t = data.access_token ?? data.accessToken;
  return typeof t === "string" && t.trim() ? t.trim() : undefined;
}

export function pickSignupUserId(res: AuthSignupResponse): string {
  return res.data?.user?.id ?? "";
}

export function pickSignupToken(res: AuthSignupResponse): string | undefined {
  return pickAuthSessionAccessToken(res.data);
}

export function pickLoginToken(res: AuthLoginResponse): string | undefined {
  return pickAuthSessionAccessToken(res.data);
}

export function pickSignupSessionId(
  res: AuthSignupResponse,
): string | undefined {
  return res.data?.sessionId;
}

export function pickSignupApiUser(
  res: AuthSignupResponse,
): AuthApiUser | undefined {
  return res.data?.user;
}

export function pickLoginApiUser(
  res: AuthLoginResponse,
): AuthApiUser | undefined {
  return res.data?.user;
}
